export enum InvestmentType {
  PUBLIC = 'Public',
  PRIVATE = 'Private',
}
